import vendorDashboardService from "../services/vendorDashboard.service";
import {
  VENDOR_DASHBOARD_DATA,
  VENDOR_DASHBOARD_ERROR,
  VENDOR_DASHBOARD_LOADING,
} from "./type";

let requestSequence = 0;

const getResponseStatus = (response) =>
  response?.status ?? response?.response?.status ?? 0;

const getResponseMessage = (response) =>
  response?.data?.message ||
  response?.data?.data?.message ||
  response?.response?.data?.message ||
  response?.response?.data?.data?.message ||
  "";

const getDashboardData = (response) => {
  const body = response?.data;
  if (!body || typeof body !== "object") return body ?? null;

  const dashboardData =
    body?.dashboard ??
    body?.dashboardData ??
    body?.dashboard_data ??
    body?.data?.dashboard ??
    body?.data?.dashboardData ??
    body?.data?.dashboard_data ??
    body?.data?.data ??
    body?.data ??
    body;
  const profileCompletionPercentage = [
    body?.profileCompletionPercentage,
    body?.profile_completion_percentage,
    body?.data?.profileCompletionPercentage,
    body?.data?.profile_completion_percentage,
    body?.data?.data?.profileCompletionPercentage,
    body?.dashboard?.profileCompletionPercentage,
    body?.dashboardData?.profileCompletionPercentage,
    body?.dashboard_data?.profileCompletionPercentage,
  ].find((value) => value !== undefined && value !== null);

  if (
    profileCompletionPercentage === undefined ||
    !dashboardData ||
    typeof dashboardData !== "object" ||
    Array.isArray(dashboardData)
  ) {
    return dashboardData;
  }

  return { ...dashboardData, profileCompletionPercentage };
};

const getErrorMessage = (error) =>
  getResponseMessage(error) || error?.message || "Unable to load dashboard data.";

export const getVendorDashboardAction = (date = "monthly") => async (dispatch) => {
  const selectedDate = ["weekly", "monthly", "yearly"].includes(date)
    ? date
    : "monthly";
  const requestId = ++requestSequence;

  dispatch({
    type: VENDOR_DASHBOARD_LOADING,
    payload: { date: selectedDate, requestId },
  });

  try {
    const response = await vendorDashboardService.getVendorDashboard(selectedDate);
    const status = getResponseStatus(response);

    if (status >= 200 && status < 300) {
      dispatch({
        type: VENDOR_DASHBOARD_DATA,
        payload: {
          date: selectedDate,
          requestId,
          data: getDashboardData(response),
        },
      });
    } else {
      dispatch({
        type: VENDOR_DASHBOARD_ERROR,
        payload: {
          requestId,
          error: getResponseMessage(response) || "Unable to load dashboard data.",
        },
      });
    }

    return response;
  } catch (error) {
    dispatch({
      type: VENDOR_DASHBOARD_ERROR,
      payload: { requestId, error: getErrorMessage(error) },
    });
    return error;
  }
};
